export default __webpack_public_path__ + "static/media/MasaiXCourseImage3.42400a03.svg";